import AppletSubgroups from "./applet-subgroup.entity";
import AppletSubgroupTypeEnum from "./applet-subgroup-type.enum";

export default class AppletProfile {
  public id: string;

  public appletSubgroups: AppletSubgroups[];

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.appletSubgroups = (data.applet_subgroups && Object.values(data.applet_subgroups).length)
      ? Object.values(data.applet_subgroups)
        .map((applet: any) => new AppletSubgroups(applet))
        .filter((applet) => applet.type !== AppletSubgroupTypeEnum.VEHICLE_PARTS)
      : [];
  }
}
